import { isOfType } from '../../../../ts-utils';
import { ensureMemberHasRightTo } from '../../members/members-actions';
import { extractMentions } from '../../../utils/extract-mentions';
import { startRequestTimer } from '../../../utils/request-timer';
import { addNewHistoryItem } from '../history/history-actions';
import { beforeCrudErrorToMessage, getMessageFromError } from '../comments-errors';
export const CANCEL_CREATING_COMMENT = 'CANCEL_CREATING_COMMENT';
export const EDIT_COMMENT_CREATE_ERROR = 'EDIT_COMMENT_CREATE_ERROR';
export const CANCEL_EDITING_COMMENT = 'CANCEL_EDITING_COMMENT';
export const EDIT_COMMENT = 'EDIT_COMMENT';
export const CREATE_COMMENT_REQUEST = 'CREATE_COMMENT_REQUEST';
export const CREATE_COMMENT_SUCCESS = 'CREATE_COMMENT_SUCCESS';
export const CREATE_COMMENT_FAILURE = 'CREATE_COMMENT_FAILURE';
export const RETRY_CREATE_COMMENT_REQUEST = 'RETRY_CREATE_COMMENT_REQUEST';
export const DELETE_COMMENT_REQUEST = 'DELETE_COMMENT_REQUEST';
export const DELETE_COMMENT_SUCCESS = 'DELETE_COMMENT_SUCCESS';
export const DELETE_COMMENT_FAILURE = 'DELETE_COMMENT_FAILURE';
export const UPDATE_COMMENT_REQUEST = 'UPDATE_COMMENT_REQUEST';
export const UPDATE_COMMENT_SUCCESS = 'UPDATE_COMMENT_SUCCESS';
export const UPDATE_COMMENT_FAILURE = 'UPDATE_COMMENT_FAILURE';
export const cancelCreatingComment = (payload) => ({
    type: CANCEL_CREATING_COMMENT,
    payload,
});
export const editCommentCreateError = (payload) => ({
    type: EDIT_COMMENT_CREATE_ERROR,
    payload,
});
export const cancelEditingComment = (payload) => ({
    type: CANCEL_EDITING_COMMENT,
    payload,
});
export const editComment = (payload, meta) => ({
    type: EDIT_COMMENT,
    payload,
    meta,
});
export const createCommentRequest = (payload) => ({
    type: CREATE_COMMENT_REQUEST,
    payload,
});
export const createCommentSuccess = (payload) => ({
    type: CREATE_COMMENT_SUCCESS,
    payload,
});
export const createCommentFailure = (payload) => ({
    type: CREATE_COMMENT_FAILURE,
    payload,
});
export function createComment({ content, resourceId, ctxFields, position, localId, asGuest, rating, }) {
    return async (dispatch, getState, { commentsService, appDefinitionId, executeBeforeCrud }) => {
        const resourceState = getState().comments[resourceId];
        if (resourceState?.type !== 'READY') {
            return;
        }
        dispatch(createCommentRequest({
            resourceId,
            content,
            localId,
            position,
            asGuest,
            rating,
        }));
        const permissionResult = await dispatch(ensureMemberHasRightTo({
            userAction: 'CREATE_COMMENT',
            resourceId,
            isGuestFlowChosen: asGuest,
        }));
        if (permissionResult !== 'OK') {
            return dispatch(createCommentFailure({
                resourceId,
                localId,
                rating,
                message: getMessageFromError(permissionResult === 'ACTION_CANCELLED' ? { type: 'SILENT' } : { type: 'PERMISSION' }, { isCreateCommentAction: true }),
            }));
        }
        const interceptorResult = await executeBeforeCrud({
            type: 'COMMENT',
            operation: 'CREATE',
            content,
        });
        if (interceptorResult.type === 'ERROR') {
            dispatch(createCommentFailure({
                resourceId,
                localId,
                rating,
                message: beforeCrudErrorToMessage(interceptorResult),
            }));
            return;
        }
        const requestTimer = startRequestTimer();
        const result = await commentsService.createComment({
            comment: {
                appId: appDefinitionId,
                contextId: ctxFields.contextId,
                contextType: ctxFields.contextType,
                resourceId,
                content: {
                    richContent: interceptorResult.content,
                    mentions: extractMentions(interceptorResult.content),
                },
            },
            createVote: resourceState.configs.withVotes,
            rating,
        });
        result.type === 'SUCCESS'
            ? dispatch(createCommentSuccess({
                resourceId,
                comment: result.response.comment,
                localId,
                requestDuration: requestTimer.stop(),
                vote: result.response.vote,
                rating: result.response.rating,
            }))
            : dispatch(createCommentFailure({
                resourceId,
                localId,
                rating,
                message: getMessageFromError(result.error, { isCreateCommentAction: true }),
            }));
    };
}
export const retryCreateCommentRequest = (payload) => ({
    type: RETRY_CREATE_COMMENT_REQUEST,
    payload,
});
export function retryCreateComment({ content, resourceId, ctxFields, localId, asGuest, rating, }) {
    return async (dispatch, getState, { commentsService, appDefinitionId, executeBeforeCrud }) => {
        const resourceState = getState().comments[resourceId];
        if (resourceState?.type !== 'READY') {
            return;
        }
        dispatch(retryCreateCommentRequest({
            resourceId,
            content,
            localId,
            asGuest,
            rating,
        }));
        const permissionResult = await dispatch(ensureMemberHasRightTo({
            userAction: 'CREATE_COMMENT',
            resourceId,
            isGuestFlowChosen: asGuest,
        }));
        if (permissionResult !== 'OK') {
            return dispatch(createCommentFailure({
                resourceId,
                localId,
                rating,
                message: getMessageFromError(permissionResult === 'ACTION_CANCELLED' ? { type: 'SILENT' } : { type: 'PERMISSION' }, { isCreateCommentAction: true }),
            }));
        }
        const interceptorResult = await executeBeforeCrud({
            type: 'COMMENT',
            operation: 'CREATE',
            content,
        });
        if (interceptorResult.type === 'ERROR') {
            dispatch(createCommentFailure({
                resourceId,
                localId,
                rating,
                message: beforeCrudErrorToMessage(interceptorResult),
            }));
            return;
        }
        const requestTimer = startRequestTimer();
        const result = await commentsService.createComment({
            comment: {
                appId: appDefinitionId,
                contextId: ctxFields.contextId,
                contextType: ctxFields.contextType,
                resourceId,
                content: {
                    richContent: interceptorResult.content,
                    mentions: extractMentions(interceptorResult.content),
                },
            },
            rating,
            createVote: resourceState.configs.withVotes,
        });
        result.type === 'SUCCESS'
            ? dispatch(createCommentSuccess({
                resourceId,
                comment: result.response.comment,
                localId,
                requestDuration: requestTimer.stop(),
                vote: result.response.vote,
                rating: result.response.rating,
            }))
            : dispatch(createCommentFailure({
                resourceId,
                localId,
                rating,
                message: getMessageFromError(result.error, { isCreateCommentAction: true }),
            }));
    };
}
export const deleteCommentRequest = (payload) => ({
    type: DELETE_COMMENT_REQUEST,
    payload,
});
export const deleteCommentSuccess = (payload) => ({
    type: DELETE_COMMENT_SUCCESS,
    payload,
});
export const deleteCommentFailure = (payload) => ({
    type: DELETE_COMMENT_FAILURE,
    payload,
});
export function deleteComment({ resourceId, commentId, }) {
    return async (dispatch, _getState, { commentsService }) => {
        dispatch(deleteCommentRequest({ resourceId, commentId }));
        const permissionResult = await dispatch(ensureMemberHasRightTo({
            userAction: 'DELETE',
            resourceId,
            commentId,
        }));
        if (permissionResult !== 'OK') {
            return dispatch(deleteCommentFailure({
                resourceId,
                commentId,
                message: getMessageFromError(permissionResult === 'ACTION_CANCELLED' ? { type: 'SILENT' } : { type: 'PERMISSION' }),
            }));
        }
        const result = await commentsService.deleteComment({
            commentId,
            cascade: false,
        });
        result.type === 'SUCCESS'
            ? dispatch(deleteCommentSuccess({ resourceId, commentId }))
            : dispatch(deleteCommentFailure({
                resourceId,
                commentId,
                message: getMessageFromError(result.error),
            }));
    };
}
export const updateCommentRequest = (payload) => ({
    type: UPDATE_COMMENT_REQUEST,
    payload,
});
export const updateCommentSuccess = (payload) => ({
    type: UPDATE_COMMENT_SUCCESS,
    payload,
});
export const updateCommentFailure = (payload) => ({
    type: UPDATE_COMMENT_FAILURE,
    payload,
});
export function updateComment({ resourceId, commentId, ctxFields, content, rating: _rating, commentByCurrentOwner, revisionId, currentComment, }) {
    return async (dispatch, getState, { commentsService, appDefinitionId, executeBeforeCrud }) => {
        /*
          comment update allows to set rating only for current owner,
          so we ensure that rating is updated only when comment by current owner is being updated
        */
        const rating = commentByCurrentOwner ? _rating : undefined;
        dispatch(updateCommentRequest({
            resourceId,
            commentId,
            content,
            rating,
        }));
        const permissionResult = await dispatch(ensureMemberHasRightTo({
            userAction: 'UPDATE',
            resourceId,
            commentId,
        }));
        if (permissionResult !== 'OK') {
            return dispatch(updateCommentFailure({
                resourceId,
                commentId,
                rating,
                message: getMessageFromError(permissionResult === 'ACTION_CANCELLED' ? { type: 'SILENT' } : { type: 'PERMISSION' }),
            }));
        }
        const interceptorResult = await executeBeforeCrud({
            type: 'COMMENT',
            operation: 'UPDATE',
            content,
        });
        if (interceptorResult.type === 'ERROR') {
            dispatch(updateCommentFailure({
                resourceId,
                commentId,
                rating,
                message: beforeCrudErrorToMessage(interceptorResult),
            }));
            return;
        }
        const requestTimer = startRequestTimer();
        const result = await commentsService.updateComment({
            comment: {
                appId: appDefinitionId,
                contextId: ctxFields.contextId,
                contextType: ctxFields.contextType,
                resourceId,
                commentId,
                revisionId,
                content: {
                    richContent: interceptorResult.content,
                    mentions: extractMentions(interceptorResult.content),
                },
            },
            rating,
        });
        if (result.type === 'SUCCESS') {
            const { comment, rating } = result.response;
            dispatch(updateCommentSuccess({
                resourceId,
                commentId,
                comment,
                requestDuration: requestTimer.stop(),
                rating,
            }));
            // revision are valid only for published comments
            if (!comment.draftContent && comment.status === 'PUBLISHED') {
                dispatch(addNewHistoryItem({
                    resourceId,
                    commentId,
                    comment: currentComment,
                    owner: getState().members.currentOwner,
                }));
            }
        }
        else {
            dispatch(updateCommentFailure({
                resourceId,
                commentId,
                rating,
                message: getMessageFromError(result.error),
            }));
        }
    };
}
export const isCommmentsCrudAction = isOfType([
    CANCEL_CREATING_COMMENT,
    EDIT_COMMENT_CREATE_ERROR,
    CANCEL_EDITING_COMMENT,
    EDIT_COMMENT,
    CREATE_COMMENT_REQUEST,
    CREATE_COMMENT_SUCCESS,
    CREATE_COMMENT_FAILURE,
    RETRY_CREATE_COMMENT_REQUEST,
    DELETE_COMMENT_REQUEST,
    DELETE_COMMENT_SUCCESS,
    DELETE_COMMENT_FAILURE,
    UPDATE_COMMENT_REQUEST,
    UPDATE_COMMENT_SUCCESS,
    UPDATE_COMMENT_FAILURE,
]);
//# sourceMappingURL=top-level-comments-crud-actions.js.map